import { useState, useEffect } from 'react';
import axios from 'axios';

const KEY = 'wl_partner_subdomain';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const rememberPartner = (subdomain) => {
  try {
    if (subdomain) localStorage.setItem(KEY, subdomain.toLowerCase());
  } catch {}
};

export const clearPartner = () => {
  try { localStorage.removeItem(KEY); } catch {}
};

export const getStoredPartner = () => {
  try { return localStorage.getItem(KEY) || null; } catch { return null; }
};

// Résout le partenaire courant : URL (?partner=) > localStorage > profil utilisateur
export const resolvePartner = (search, user) => {
  const fromUrl = new URLSearchParams(search || window.location.search).get('partner');
  if (fromUrl) { rememberPartner(fromUrl); return fromUrl.toLowerCase(); }
  return getStoredPartner() || user?.partner_subdomain || null;
};

export const partnerHome = (subdomain) => (subdomain ? `/p/${subdomain}` : '/');

export const withPartner = (path, subdomain) => {
  if (!subdomain) return path;
  return `${path}${path.includes('?') ? '&' : '?'}partner=${encodeURIComponent(subdomain)}`;
};

// Hook : contexte partenaire + branding public (nom / logo / couleur)
export const usePartner = (search, user) => {
  const subdomain = resolvePartner(search, user);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!subdomain) { setInfo(null); return; }
    let cancelled = false;
    axios.get(`${API}/partners/by-subdomain/${subdomain}`)
      .then((res) => { if (!cancelled) setInfo(res.data); })
      .catch(() => { if (!cancelled) setInfo(null); });
    return () => { cancelled = true; };
  }, [subdomain]);

  return {
    subdomain,
    info,
    isPartner: !!subdomain,
    home: partnerHome(subdomain),
    link: (path) => withPartner(path, subdomain),
    color: info?.primary_color || null,
    name: info?.name || null,
    logo: info?.logo_url || null,
  };
};
